import { Middleware } from "redux";

import { ActivityActions } from "@com.mgmtp.a12.client/client-core/lib/core/activity";
import { Commands } from "@com.mgmtp.a12.formengine/formengine-core/lib/back-end/store";
import { FormActivity, FormEngineActions } from "@com.mgmtp.a12.formengine/formengine-core/lib/client-extensions";
import { Locale } from "@com.mgmtp.a12.utils/utils-localization/lib/main";

import { selectHasNeededPermissions } from "../../../utilities/user";
import { getApplicationKey } from "../../../utilities/applicationKeyUtils";
import { hasUpdateDocumentPermission } from "../../../utilities/permissionUtils";

import { isStammdatenDocumentEditable } from "../utils";
import { isStammdatenDocument } from "../types";

export const setStammdatenReadonlyMiddleware: Middleware<unknown, { locale: Locale }> = api => next => action => {
	const result = next(action);
	if (!ActivityActions.setData.match(action)) {
		return result;
	}

	if (!(
		FormActivity.Data.SingleDocumentData.isInstance(action.payload.data) &&
		isStammdatenDocument(action.payload.data.document)
	)) {
		return result;
	}

	const sdKey = getApplicationKey(action.payload.data.document.modelId) ?? undefined;
	const hasPermission = selectHasNeededPermissions(hasUpdateDocumentPermission, sdKey)(api.getState());
	if (!hasPermission || !isStammdatenDocumentEditable(action.payload.data.document.root)) {
		api.dispatch(
			FormEngineActions.command({
				activityId: action.payload.activityId,
				engineEvent: Commands.setReadonly(true)
			})
		);
		return result;
	}
};
